import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyList from "./cargo-company-list";
import CargoCompanyListParams from "./cargo-company-list-params";

const useCargoCompanyList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<CargoCompanyList>({
      data: [],
    });

  const load = async (params: CargoCompanyListParams, signal: AbortSignal) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoCompanyList = await cargoCompanyService.getCargoCompanyList(
        params,
        signal,
      );

      setData(cargoCompanyList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useCargoCompanyList;
